export default "__VITE_ASSET__BOQnSM4L__"